// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.UpdateLandlordPaymentMethodWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { UpdatePaymentMethodWebApiRequestDto, UpdatePaymentMethodWebApiResponseDto } from '../..';

export const UpdateLandlordPaymentMethodWebApiHandler_updateLandlordPaymentMethod_Path =
  '/api/web/v1/updateLandlordPaymentMethod';

/**
 * create or update landlord payment method
 */
export const UpdateLandlordPaymentMethodWebApiHandler_updateLandlordPaymentMethod = (
  postData: UpdatePaymentMethodWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UpdatePaymentMethodWebApiRequestDto, UpdatePaymentMethodWebApiResponseDto>(
    {
      endpoint: UpdateLandlordPaymentMethodWebApiHandler_updateLandlordPaymentMethod_Path,
      method: 'POST',
      contextPath: '/rent-payment',
      postData: postData,
    },
    client,
  );
};
